import React from 'react'
import { k, useCss } from 'kremling'
import { FieldHeaderContent } from './field-header-content.component'

type WorkflowDescriptionProps = {
  field: Field
  section: ActivitySection
}

export function WorkflowDescription({ field, section }: WorkflowDescriptionProps) {
  const scope = useCss(css)

  return (
    <div {...scope}>
      <FieldHeaderContent
        field={field}
        section={section}
      />
    </div>
  )
}

const css = k`
  .description-container {
    line-height: 2rem;
  }

  .description-container img {
    max-width: 100%;
    border-radius: $base-border-radius;
  }
`
